import { PublicUserOrganization } from "../../__generated__/graphql";
import { cn } from "../../lib/utils";
import Avatar from "../Avatar";
import Checkbox from "../Checkbox";
import RadioButton from "../RadioButton";

export default function UserOrganizationItem({
  userOrganization,
  selected,
  onClick,
  selectionMode = "checkbox",
  className,
}: {
  userOrganization: PublicUserOrganization;
  selected?: boolean;
  onClick?: (userOrganization: PublicUserOrganization) => void;
  selectionMode?: "checkbox" | "radio";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 text-xs border border-border bg-card rounded-md p-2 h-full",
        onClick && "cursor-pointer hover:bg-card/40",
        className
      )}
      onClick={() => onClick?.(userOrganization)}
    >
      {selected !== undefined ? (
        selectionMode === "checkbox" ? (
          <Checkbox checked={selected} />
        ) : (
          <RadioButton checked={selected} />
        )
      ) : null}

      <Avatar userOrganization={userOrganization} size="small" />

      <div className="flex flex-col truncate">
        {userOrganization.organizationName !== userOrganization.name ? (
          <div className="text-accent">{userOrganization.organizationName}</div>
        ) : null}
        <div className="font-bold text-primary">{userOrganization.name}</div>
        {userOrganization.jobTitle ? (
          <div className="text-secondary">{userOrganization.jobTitle}</div>
        ) : null}
      </div>
    </div>
  );
}
